export const API_URL = 'https://nucleus-api.videahealth.io';
export const PARSE_APPLICATION_ID =
  'DwjY3wpxaUUR2Ehd4acfuRATcHuei7sPr4aHhUUjGB';
export const NETWORK_REQUEST_TIMEOUT_IN_MILLIS = 60000;
export const VIDEA_BEACON_URL = 'ws://localhost:8090/Watcher';
export const BUILD_CONFIGURATION = 'NON_FDA';
export const SHOW_VALIDATION_DROP_DOWN_MENUS = false;
export const MIXPANEL_TOKEN = '325c4e7fd6f0ebeecd71b656d7987473';
export const USERPILOT_TOKEN = 'NX-2caf528a';
export const LANGFUSE_PUBLIC_KEY = 'pk-lf-a22f8605-a51c-45b2-b49f-955d92647163';
export const LANGFUSE_NOTES_PUBLIC_KEY =
  'pk-lf-bd6d839f-f277-44af-b148-4d9a91702e64';
export const LANGFUSE_BASE_URL = 'https://langfuse.synapse.prod.videahealth.io';
export const OKTA_DOMAIN = 'https://login.videahealth.io';
export const OKTA_CLIENT_ID = '0oa3m5bpib9EefwkJ5d7';
export const SENTRY_ENABLED = true;
export const DEX_CONVERSION_API_URL = 'https://dex-api.videahealth.io';
export const OPS_DASHBOARD_SHOW_WATCHLIST = false;
export const AIRTABLE_API_KEY =
  'patigtWu02gTD7Swh.d508708a2c5a9d5721564b0896d2ae184f3a64dde46ad3d4852c58ef161955c6';
export const AIRTABLE_BASE_ID = 'appoQ9I2TU8c6DDkj';

// Keycloak / Synapse authentication
export const AMBIENT_API_URL = 'https://ambient.api.synapse.prod.videahealth.io';
export const KEYCLOAK_URL = 'https://keycloak.api.synapse.prod.videahealth.io';
export const KEYCLOAK_REALM = 'synapse';
export const KEYCLOAK_CLIENT_ID = 'synapse-spa';
export const SYNAPSE_TOKEN_URL = 'https://token.external.synapse.prod.videahealth.io';

// Elastic APM Configuration
export const ELASTIC_APM_ENABLED = true;
export const ELASTIC_APM_ENVIRONMENT = 'production';
